import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import Tabs from './Tabs';
import {TABS_STRUCTURE} from "../misc/Shared";
import Financials from './Financials';
import Overview from './Overview';
import Issues from './Issues';
import Background from './Background';
import Performance from './Performance';
import webservice, {axiosErrorHandler} from "../common/Webservice";

const propTypes = {
	currentPageTitle: PropTypes.string,

	// The browser history object (provided by react router)
	history: PropTypes.object.isRequired,

	user: PropTypes.object,
};

const defaultProps = {
	currentPageTitle: undefined,
};

// Props connected to the store
const mapStateToProps = (state) => {
	return {
		currentPageTitle: state.app.currentPageTitle,
		currentTab: state.app.currentTab,
		user: state.user,
	};
};

class Home extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
		if (this.props.user && this.props.user.expires_at > Math.floor(new Date().getTime()/1000.0)) {
			webservice.admin.user.get().catch(error => {
				axiosErrorHandler(error, true);
			});
		}
	}

	render() {
		return (
			<React.Fragment>
				<h1>{this.props.currentPageTitle ? this.props.currentPageTitle: '\u00a0'}</h1>
				<Tabs history={this.props.history} />
				<div className="content fr-view">
					{{
						[TABS_STRUCTURE.OVERVIEW]: <Overview/>,
						[TABS_STRUCTURE.ISSUES]: <Issues history={this.props.history}/>,
						[TABS_STRUCTURE.PERFORMANCE]: <Performance/>,
						[TABS_STRUCTURE.BACKGROUND]: <Background/>,
						[TABS_STRUCTURE.FINANCIALS]: <Financials/>
					}[this.props.currentTab]}
				</div>
			</React.Fragment>
		);
	}
}

Home.propTypes = propTypes;
Home.defaultProps = defaultProps;

export default connect(mapStateToProps)(Home);